/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * List of restrictions
 */
export interface DrivingLicenseRestrictionResult { 
    /**
     * Code of the restriction.
     */
    restrictionCode?: string;
    /**
     * Description of the restriction.
     */
    description?: string;
}

